import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import { CommandPalette } from "@/components/CommandPalette";
import { VisitorTracker } from "@/components/VisitorTracker";
import { Loader2 } from "lucide-react";
import Landing from "@/pages/Landing";
import Diagnostic from "@/pages/Diagnostic";
import MonParcours from "@/pages/MonParcours";
import Resultat from "@/pages/Resultat";
import Formations from "@/pages/Formations";
import Calculatrices from "@/pages/Calculatrices";
import DeckViewer from "@/pages/DeckViewer";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";

const Shell = ({ children, hideChrome }) => (
  <div className="App flex flex-col min-h-screen">
    {!hideChrome && <Header />}
    <main className="flex-1">{children}</main>
    {!hideChrome && <Footer />}
  </div>
);

const Protected = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready || user === null) {
    return <div className="min-h-screen grid place-items-center"><Loader2 className="animate-spin text-[#012141]" /></div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Shell><Landing /></Shell>} />
          <Route path="/diagnostic" element={<Shell><Diagnostic /></Shell>} />
          <Route path="/mon-parcours" element={<Shell><MonParcours /></Shell>} />
          <Route path="/resultat" element={<Shell><Resultat /></Shell>} />
          <Route path="/formations" element={<Shell><Formations /></Shell>} />
          <Route path="/calculatrices" element={<Shell><Calculatrices /></Shell>} />
          <Route path="/formations/:slug" element={<Shell hideChrome><DeckViewer /></Shell>} />
          <Route path="/admin/login" element={<Shell><Login /></Shell>} />
          <Route path="/admin" element={<Protected><Shell><Admin /></Shell></Protected>} />
        </Routes>
        <Toaster position="top-center" richColors />
        <CommandPalette />
        <VisitorTracker />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
